import axios from 'axios'
import { IS_DEV, API_WX_SIGNATURE, WX_APP_ID } from '@src/common/const'

export function configWechatSharing({title, link, desc = ''}) {
  const wx = window.wx

  if (wx) {
    axios
      .get(API_WX_SIGNATURE, {
        params: { url: location.href }
      })
      .then((res) => {
        const { data:{timestamp, nonceStr, signature} } = res

        wx.config({
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
          appId: WX_APP_ID,
          timestamp,
          nonceStr,
          signature,
          debug: IS_DEV
        })
      })

    wx.error((err) => console.error(err))

    wx.ready(() => {
      const imgUrl = document.querySelector('meta[property="weixin:image"]').getAttribute('content')

      const options = {
        title,
        link,
        imgUrl,
        desc
      }

      wx.onMenuShareTimeline(options)
      wx.onMenuShareAppMessage(options)
    })
  }
}
